import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7efe54d5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7efe54d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efe54d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7efe54d5')) {
      api.createRecord('7efe54d5', component.options)
    } else {
      api.reload('7efe54d5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7efe54d5&scoped=true&", function () {
      api.rerender('7efe54d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/customers/basicInfo/index.vue"
export default component.exports